import { UserIcon } from 'components/Icons';
import LayoutContext from 'components/Layout/LayoutContext';
import CentralNotificacao from 'components/__ASSESSOR__/centralNotificacao/central-notificacao';
import { MenuList } from 'components/__SHARED__/TopBar/menuList';
import { AuthContext } from 'context/authContext/AuthContext';
import { isAssociadoProfile } from 'helpers/utils/AuthUtils';
import useAllowChangeRoute from 'hooks/useAllowChangeRoute';
import { AssessorRoutePath, AssociadoRoutePath } from 'library/Routes';
import translation from 'locales/translation';
import {
  Button,
  ButtonThemes,
  Col,
  DropdownItem,
  DropdownMenu,
  HamburgerIcon,
  Header,
  HeaderType,
  IconButton,
  IconButtonType,
  Menu,
  Row,
  SicrediLogo,
} from 'plataforma-fundacao-componentes';
import { Fragment, useCallback, useContext, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import {
  leftMenuActionsClose,
  leftMenuActionsOpen,
} from 'store/modules/LeftMenuActions';
import { IReducer } from 'store/Reducer';
import TopBarMenus from './TopBarMenus';

interface Props {
  readOnly?: boolean;
  mostrarSaudacao?: boolean;
  disableLeftMenu?: boolean;
}

export default function TopBar({
  readOnly,
  mostrarSaudacao,
  disableLeftMenu,
}: Props) {
  const history = useHistory();
  const layoutContext = useContext(LayoutContext);
  const [handleChangeRoute] = useAllowChangeRoute();

  const { usuario, logged } = useSelector((state: IReducer) => state.auth);

  const dispatch = useDispatch();
  const location = useLocation();

  const userName = useMemo(() => {
    if (logged && usuario) {
      return usuario.nome.split(' ')[0];
    }
    return null;
  }, [usuario, logged]);

  const [dropdownOpened, setDropdownOpened] = useState(false);
  const [opened, setOpened] = useState<boolean>(false);

  const { logout } = useContext(AuthContext);
  const [handleLogout] = useAllowChangeRoute();

  const isAssociado = useMemo(() => {
    if (usuario) {
      return isAssociadoProfile(usuario.perfil);
    }
  }, [usuario]);

  const { leftMenu } = useSelector((state: IReducer) => state);

  const openLeftMenu = useCallback(() => {
    dispatch(leftMenuActionsOpen());
  }, [dispatch]);

  return (
    <Fragment>
      <Header
        theme={HeaderType.Branco}
        leftContent={
          <Fragment>
            {!readOnly && !disableLeftMenu && logged && usuario ? (
              <IconButton
                id={'hamburger-button'}
                aria-label={'menu'}
                icon={<HamburgerIcon />}
                disabled={disableLeftMenu}
                onClick={() => {
                  setOpened(!opened);
                  openLeftMenu();
                }}
                theme={IconButtonType.Primary}
              />
            ) : null}
            <div style={{ margin: '0 8px' }} />
            {usuario?.perfil && (
              <IconButton
                id={'home-icon'}
                aria-label={'página inicial'}
                icon={<SicrediLogo height={30} />}
                disabled={readOnly}
                onClick={() => {
                  if (!readOnly) {
                    handleChangeRoute().then(() => {
                      history.push(
                        isAssociadoProfile(usuario.perfil)
                          ? AssociadoRoutePath
                          : AssessorRoutePath
                      );
                    });
                  }
                }}
              />
            )}
          </Fragment>
        }
        rightContent={
          !readOnly && !disableLeftMenu && logged && usuario ? (
            <DropdownMenu
              opened={dropdownOpened}
              setOpened={setDropdownOpened}
              closeOnOutClick
              content={
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                  }}
                >
                  {usuario?.nome ? (
                    <DropdownItem alignRight disabled label={usuario?.nome} />
                  ) : undefined}
                  <DropdownItem
                    alignRight
                    label={translation.UserMenu.sair}
                    onClick={() => {
                      handleLogout().then(() => {
                        logout!();
                      });
                    }}
                  />
                </div>
              }
            >
              <Row>
                <Col gap={16}>
                  {[AssessorRoutePath, `${AssessorRoutePath}/`].includes(
                    location.pathname
                  ) ? (
                    <CentralNotificacao />
                  ) : (
                    <Fragment />
                  )}
                  <Button
                    rightIcon={<UserIcon />}
                    onClick={() => setDropdownOpened(!dropdownOpened)}
                    theme={ButtonThemes.HeaderUserSecondary}
                  >
                    {!readOnly && userName && mostrarSaudacao
                      ? translation.TopBar.saudacao(userName)
                      : null}
                  </Button>
                </Col>
              </Row>
            </DropdownMenu>
          ) : undefined
        }
      />
      <Menu
        logo={<SicrediLogo height={28} />}
        hamburgerMenu
        buscar
        opened={leftMenu.opened}
        setOpened={() =>
          dispatch(
            leftMenu.opened ? leftMenuActionsClose() : leftMenuActionsOpen()
          )
        }
        items={
          MenuList({
            isAssociado: usuario && isAssociado,
          })!
        }
      />
      <TopBarMenus menuItems={layoutContext.pageMenuItems} />
    </Fragment>
  );
}
